import { Trans, useTranslation } from "react-i18next";
import {
  ListContaniner,
  ListItem,
  PrivacyPolicyText,
  SectionContainer,
  SectionSubTitle,
  SectionSubTitle2,
  SectionTitle,
  SubSectionContainer,
} from "../PrivacyPolicyContent.styled";

export const PersonalDataSectionContent = (
  props: PersonalDataSectionContentProps
) => {
  const { i18n } = useTranslation();

  return (
    <SectionContainer>
      <SectionTitle>
        <Trans i18nKey={"privacyPolicy.personalData.title"} />
      </SectionTitle>
      <SubSectionContainer>
        <SectionSubTitle>
          <Trans i18nKey={"privacyPolicy.personalData.subtitle"} />
        </SectionSubTitle>
        <SectionSubTitle2>
          <Trans i18nKey={"privacyPolicy.personalData.personalDataTitle"} />
        </SectionSubTitle2>
        <PrivacyPolicyText>
          <Trans
            i18nKey={"privacyPolicy.personalData.personalDataDescription"}
          />
        </PrivacyPolicyText>
        <div>
          {(
            i18n.t("privacyPolicy.personalData.personalDataList", {
              returnObjects: true,
            }) as string[]
          ).map((definition, index) => (
            <ListItem
              key={index}
              dangerouslySetInnerHTML={{ __html: definition }}
            />
          ))}
        </div>
        <SectionSubTitle2>
          <Trans i18nKey={"privacyPolicy.personalData.usageData"} />
        </SectionSubTitle2>
        <ListContaniner>
          {(
            i18n.t("privacyPolicy.personalData.usageDataDescription", {
              returnObjects: true,
            }) as string[]
          ).map((definition, index) => (
            <PrivacyPolicyText>
              <Trans i18nKey={definition} />
            </PrivacyPolicyText>
          ))}
        </ListContaniner>
      </SubSectionContainer>
    </SectionContainer>
  );
};

export interface PersonalDataSectionContentProps {}
